module.exports = __webpack_public_path__ + "static/media/logoSFSB_hr.155fd5dd.png";